import { StateKey } from 'common/utils/flipState'
import { CommonState } from 'common/types'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'
import { fetchPhotoVideos as fetchServerPhotoVideos } from 'common/services/review'
import { PhotoVideosState } from 'common/types/entities/review'

const FETCH = 'review/photoVideos/FETCH'

const initialState: PhotoVideosState = {
  items: [],
  cacheParam: null,
}

export const fetchPhotoVideos = (curState: StateKey, reviewIds: number[], merchantNo: string) => async (
  dispatch,
  getState: () => CommonState,
) => {
  const cacheParam = createCacheParam(FETCH, 'fetchPhotoVideos', { curState, reviewIds })

  if (isCacheHit(getState().photoVideos[curState], cacheParam)) {
    return
  }

  dispatch({
    curState,
    cacheParam,
    items: await fetchServerPhotoVideos(reviewIds, merchantNo),
    type: FETCH,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        items: action.items,
        cacheParam: action.cacheParam,
      }
    default:
      return state
  }
}

export default reducer
